var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.323 17.455a5.261 5.261 0 0 0 3.666-2.034 6.517 6.517 0 0 0 1.467-3.92 3.161 3.161 0 0 0 0-.545 5.962 5.962 0 0 0-3.99 2.18A6.133 6.133 0 0 0 26 16.925a1.76 1.76 0 0 0 0 .501l.323.03zM22.025 39c1.672 0 2.406-1.164 4.488-1.164 2.083 0 2.582 1.135 4.4 1.135 1.819 0 3.036-1.754 4.18-3.464a15.894 15.894 0 0 0 1.863-3.964 6.14 6.14 0 0 1-2.648-2.288 6.182 6.182 0 0 1-.975-3.37 6.42 6.42 0 0 1 .79-3.05 6.384 6.384 0 0 1 2.144-2.3 6.301 6.301 0 0 0-2.32-2.067 6.267 6.267 0 0 0-3.019-.704c-2.053 0-3.725 1.282-4.767 1.282-1.041 0-2.625-1.208-4.4-1.208-3.373 0-6.79 2.947-6.79 8.326a17.745 17.745 0 0 0 2.83 9.27C19.18 37.394 20.34 39 22.025 39z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.f064c7e72786592080b58b27ea465c60.svg";
export { ForwardRef as ReactComponent };